import $api from "@/zapi-frontend/shared/api/axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

export type TDeleteProjectDimensionPayload = {
  orgId: number;
  dimensionId: number;
};

export function useDeleteProjectDimension(
  options?: UseMutationOptions<number, AxiosError<{ message: string }>, TDeleteProjectDimensionPayload>
) {
  return useMutation({
    mutationKey: ["deleteProjectDimension"],
    mutationFn: async ({ orgId, dimensionId }: TDeleteProjectDimensionPayload) => {
      await $api.delete(`/organizations/${orgId}/project-dimensions/${dimensionId}?confirm=true`);
      return dimensionId;
    },
    ...options
  });
}
